module.exports = __webpack_public_path__ + "img/allDone.df7a784e.svg";